import * as React from "react";
const SvgProfile = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}><path d="M0 0h24v24H0z" data-name="Trazado 403" style={{
    fill: "none"
  }} /><path d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4m0 2c-2.67 0-8 1.34-8 4v1a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1c0-2.66-5.33-4-8-4" className="profile_svg__cls-2" data-name="Trazado 404" /></svg>;
export { SvgProfile as ReactComponent };